import * as types from '../mutation-types'

const state = {
  showWidget: false,
  showBrowserWarning: true,
  notAvailableOnMobileWarning: true
}

const getters = {
  shouldShowWidget: (state) => {
    return state.showWidget
  },
  shouldShowBrowserWarning: (state) => {
    return state.showBrowserWarning
  },
  shouldShowNotAvailableOnMobile: (state) => {
    return state.notAvailableOnMobileWarning
  }
}

const actions = {
  updateShowWidget ({ commit }, showWidget) {
    commit(types.UPDATE_SHOW_WIDGET, showWidget)
  },
  closeBrowserWarning ({ commit }) {
    if (localStorage.getItem('browserWarning') || localStorage.getItem('notAvailableOnMobileWarning')) {
      commit(types.SET_BROWSER_WARNING, false)
      commit(types.SET_NOT_AVAILABLE_ON_MOBILE, false)
    }
  }
}

const mutations = {
  [types.UPDATE_SHOW_WIDGET] (state, showWidget) {
    state.showWidget = showWidget
  },
  [types.SET_BROWSER_WARNING] (state, showBrowserWarning) {
    state.showBrowserWarning = showBrowserWarning
  },
  [types.SET_NOT_AVAILABLE_ON_MOBILE] (state, notAvailableOnMobileWarning) {
    state.notAvailableOnMobileWarning = notAvailableOnMobileWarning
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
